var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-table-column", {
    attrs: {
      label: _vm.label,
      prop: _vm.prop,
      "class-name": "fee",
      sortable: _vm.sortable,
      formatter: _vm.formatter
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }